import { TAG, PLACE, PLACE_DETAIL } from '@utils/constant'
export default [
  {
    key: 'id',
    value: '',
    label: 'id',
    name: 'id',
    as: 'input',
    variant: ['edit'],
    plaintext: true,
    hiddenEdit: true,
  },
  {
    key: 'company',
    value: '',
    label: 'company',
    name: 'company',
    as: 'input',
    variant: ['edit'],
    plaintext: true,
    hiddenEdit: true,
  },
  {
    key: 'place',
    value: '',
    label: 'place',
    name: 'place',
    as: 'radioGroup',
    options: [
      {
        value: `${PLACE.APP}`,
        label: PLACE_DETAIL[PLACE.APP],
      },
      {
        value: `${PLACE.CMS}`,
        label: PLACE_DETAIL[PLACE.CMS],
      },
    ],
    checked: '1',
    variant: ['add'],
  },
  {
    key: 'place_text',
    value: '',
    label: 'place',
    name: 'place',
    as: 'input',
    variant: ['edit'],
    plaintext: true,
  },
  {
    key: 'order',
    value: '',
    label: 'order',
    name: 'order',
    as: 'inputNumber',
    variant: ['add', 'edit'],
    plaintext: true,
    rules: { valueRange: { min: 1, max: 99 } },
  },
  {
    key: 'status',
    value: '',
    label: 'status',
    name: 'status',
    as: 'input',
    variant: ['edit'],
    plaintext: true,
  },
  {
    key: 'quote',
    value: '',
    label: 'quote',
    name: 'quote',
    as: 'select',
    variant: ['add'],
  },
  {
    key: 'tag',
    value: '',
    label: 'tag',
    name: 'tag',
    as: 'select',
    variant: ['add', 'edit'],
    hiddenView: true,
  },
  {
    key: 'title',
    value: '',
    label: 'title',
    name: 'title',
    placeholder: 'タイトルを入力してください',
    as: 'input',
    variant: ['add', 'edit'],
    rules: { required: true, max: 255 },
    hiddenView: true,
  },
  {
    key: 'content',
    value: '',
    label: 'content',
    name: 'content',
    placeholder: '本文を入力してください',
    as: 'area',
    variant: ['add', 'edit'],
    rules: { required: true, max: 1000 },
    hiddenView: true,
  },
  {
    key: 'image_binary',
    value: '',
    label: 'image',
    name: 'image_binary',
    as: 'inputFile',
    variant: ['add', 'edit'],
    hiddenView: true,
  },
  {
    key: 'link',
    value: '',
    label: 'link',
    name: 'link',
    as: 'input',
    placeholder: '例）https://feelline.jp/',
    variant: ['add', 'edit'],
    rules: { required: false, max: 2000 },
  },
  {
    key: 'created_name',
    value: '',
    label: 'createdName',
    name: 'created_name',
    as: 'input',
    variant: ['edit'],
    plaintext: true,
    hiddenEdit: true,
  },
  {
    key: 'updated_name',
    value: '',
    label: 'updatedName',
    name: 'updated_name',
    as: 'input',
    variant: ['edit'],
    plaintext: true,
    hiddenEdit: true,
  },
  {
    key: 'hits',
    value: '',
    label: 'hits',
    name: 'hits',
    as: 'input',
    variant: ['edit'],
    plaintext: true,
    hiddenEdit: true,
  },
  {
    key: 'clicks',
    value: '',
    label: 'clicks',
    name: 'clicks',
    as: 'input',
    variant: ['edit'],
    plaintext: true,
    hiddenEdit: true,
  },
  {
    key: 'period',
    lower: 'start',
    upper: 'end',
    value: {},
    label: 'period',
    as: 'period',
    variant: ['edit'],
    hiddenEdit: true,
  },
]

export const basicInfoFields = {
  id: '',
  company: '',
  place: '1',
  order: 1,
  status: '',
  link: '',
  quote: '',
  tag: '',
  title: '',
  content: '',
  image_binary: '',
  image_url: '',
  place_text: '',
  agent_id: '',
  created_name: '',
  updated_name: '',
  hits: 0,
  clicks: 0,
  start: '',
  end: '',
}

export const basicOptions = {
  tag: TAG.map((item) => {
    return { value: item, label: item }
  }),
  quote: [],
}
